import settings from '../liferay/settings';
import ApiUtils from '../liferay/ApiUtils';
import { getLifeRaySiteGroupId } from '../liferay/helper'

/** Специальные действия для получения информации о wiki страницах
 * Например, список нодов, вложенных страниц
 */
export const WikiActions = {
  EMPTY: () => ({
    type: WikiActions.EMPTY,
  }),
  LOAD_STARTED: () => ({
    type: WikiActions.LOAD_STARTED,
  }),
  LOAD_ERROR: (error) => ({
    type: WikiActions.LOAD_ERROR, 
    error,
  }),
  NODES: (nodes) => ({
    type: WikiActions.NODES, 
    nodes,
  }),
  NODEPAGES: (nodeId, pages) => ({
    type: WikiActions.NODEPAGES, 
    nodeId, pages,
  }),
  SELECTED: (page) => ({
    type: WikiActions.SELECTED, 
    page,
  }),

  /** Загрузить список доступных wiki узлов */
  loadNodes: (status=0) => dispatch => {
    //console.log('initialization', table);
    //Сделаем событие, что начали загружать данные 
    dispatch(WikiActions.LOAD_STARTED());
    const options = {...settings.options};
    const formData = {
      'cmd': JSON.stringify({'/wiki.wikinode/get-nodes':{}}),
      'formDate': new Date().getMilliseconds(),
      'groupId': getLifeRaySiteGroupId(),
      'status': status
    }
    return ApiUtils.postToLifeRay721(formData, options)
      .then ((response) =>{
        console.log("Done!", response);
        //const { count, items, years} = response;
        dispatch(WikiActions.NODES(response));
        return Promise.resolve(response);
      })
      .catch(e => { 
        dispatch(WikiActions.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
        return Promise.reject(e);
      });
  },

  /** Загрузить список доступных wiki статей для узла  */
  loadNodePages: (nodeId, max=100) => dispatch => {
    //Сделаем событие, что начали загружать данные 
    dispatch(WikiActions.LOAD_STARTED());
    const options = {...settings.options};
    const formData = {
      'cmd': JSON.stringify({'/wiki.wikipage/get-node-pages':{}}),
      'formDate': new Date().getMilliseconds(),
      'nodeId': nodeId,
      'max': max
    }
    return ApiUtils.postToLifeRay721(formData, options)
      .then ((response) =>{
        console.log("Done!", response);
        //const { count, items, years} = response;
        dispatch(WikiActions.NODEPAGES(nodeId, response));
        return Promise.resolve(response);
      })
      .catch(e => { 
        dispatch(WikiActions.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
        return Promise.reject(e);
      });
  },

};
